// extracted by mini-css-extract-plugin
export var login = "Login-module--login--WeolH";
export var header = "Login-module--header--Q3pxQ";
export var divider = "Login-module--divider--M+JDe";
export var container = "Login-module--container--I-bOP";
export var intro = "Login-module--intro--S+0pr";
export var loginForm = "Login-module--loginForm--wfFH-";
export var forgotPassword = "Login-module--forgot-password--DIGZk";